import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTableHeader, IcosTableColumn, IcosTableBody } from './children'
import { IcosTable } from './table'
import { IcosTableFormat } from './utils/format'
import { IcosSharedModule } from '../shared/module'

@NgModule({
  declarations: [
    IcosTable,
    IcosTableHeader,
    IcosTableColumn,
    IcosTableBody,
  ],
  exports: [
    IcosTable,
    IcosTableColumn,
  ],
  imports: [CommonModule, IcosSharedModule],
  entryComponents: [IcosTable],
})
export class IcosTableModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosTableModule, providers: [IcosTableFormat] }
  }
}
